import { render, staticRenderFns } from "./RateConfiguration.vue?vue&type=template&id=c1926a4c&scoped=true&"
import script from "./RateConfiguration.vue?vue&type=script&lang=js&"
export * from "./RateConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./RateConfiguration.vue?vue&type=style&index=0&id=c1926a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1926a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1926a4c')) {
      api.createRecord('c1926a4c', component.options)
    } else {
      api.reload('c1926a4c', component.options)
    }
    module.hot.accept("./RateConfiguration.vue?vue&type=template&id=c1926a4c&scoped=true&", function () {
      api.rerender('c1926a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/ModalComponents/RateConfiguration.vue"
export default component.exports